var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 959,
    height: 959,
    viewBox: "0 0 959 959",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.667 334.867C160.249 334.867 95.867 399.246 95.867 478.667C95.867 558.089 160.249 622.468 239.667 622.468H383.468C409.942 622.468 431.401 643.928 431.401 670.401C431.401 696.875 409.942 718.335 383.468 718.335H239.667C107.303 718.335 0 611.031 0 478.667C0 346.303 107.303 239 239.667 239H383.468C409.942 239 431.401 260.461 431.401 286.933C431.401 313.406 409.942 334.867 383.468 334.867H239.667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.667 478.668C239.667 452.194 261.128 430.734 287.601 430.734H671.069C697.543 430.734 719.002 452.194 719.002 478.668C719.002 505.141 697.543 526.601 671.069 526.601H287.601C261.128 526.601 239.667 505.141 239.667 478.668Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M719.003 334.867C798.424 334.867 862.803 399.246 862.803 478.667C862.803 558.089 798.424 622.468 719.003 622.468H575.202C548.728 622.468 527.269 643.928 527.269 670.401C527.269 696.875 548.728 718.335 575.202 718.335H719.003C851.366 718.335 958.67 611.031 958.67 478.667C958.67 346.303 851.366 239 719.003 239H575.202C548.728 239 527.269 260.461 527.269 286.933C527.269 313.406 548.728 334.867 575.202 334.867H719.003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.61254b0ef74cdd1522bdcba29fd9b13f.svg";
export { ForwardRef as ReactComponent };